export enum RibbonVariant {
  NEW = 'NEW',
  BETA = 'BETA',
  LEGACY = 'LEGACY',
}
